module.exports = __webpack_public_path__ + "static/media/tritronik.806770a0.jpeg";